<template lang="pug">
    .log
        .log-type(:class="log.type")
        .log-date {{ dateFormat(log.date) }}
        .log-category {{ log.category }}
        .log-message {{ log.message }}
</template>

<script>
import moment from "moment";

export default {
  name: "Log",
  props: {
    log: {
      type: Object,
      default() {
        return {
          type: "error",
          date: new Date(),
          category: "Error",
          message: "Wrong log data"
        };
      }
    }
  },
  methods: {
    dateFormat(date) {
      return moment(date).calendar();
    }
  }
};
</script>

<style lang="scss" scoped>
.log {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 2rem;

  .log-type {
    width: 0.5rem;
    height: 0.5rem;
    margin: 0 0.5rem;
    border-radius: 100%;
    background-color: $defaultColor;

    &.error {
      background-color: $errorColor;
    }
    &.warn {
      background-color: $warnColor;
    }
    &.info {
      background-color: $infoColor;
    }
    &.success {
      background-color: $successColor;
    }
  }

  .log-date {
    margin-right: 0.5rem;
    color: $defaultColor;
    font-weight: 300;
    opacity: 0.4;
  }

  .log-category {
    margin-right: 0.5rem;
    font-weight: 500;
    &:after {
      content: ":";
    }
  }
}
</style>
